// extracted by mini-css-extract-plugin
export default {"settingsSidebarWarning":"l7VOngcoDCONKObVfbbZ","icon":"SyfJCPyqofeR_sharha_","actionRequiredIcon":"MwaCaO8icgXkhB5Pqt6n"};